export function isNullOrEmpty(value: string) {
  return value === null || value === undefined || value.trim() === '';
}

export function isValidEmail(email: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
